export class NovaSenha {
  senhaAntiga: string;
  novaSenha: string;
  confirmacaoSenha: string;
  email: string;
}
